// filepath: c:/Develop/Cellcom.Digital.Cms/src/Spa.Frontend/src/Components/Block/RouterSelfInstallBlock/index.tsx
import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import RouterSelfInstallBlockData from 'Models/Content/RouterSelfInstallBlockData';
import RouterSelfInstallBlockMain from './main';

export default class RouterSelfInstallBlock extends EpiComponent<RouterSelfInstallBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <RouterSelfInstallBlockMain iContent={this.props.data} context={this.getContext()} />;
  }
}
